import React, { useState } from 'react';
import './ButtonsEditor.css';

interface ButtonsEditorProps {
  selectedSection: string | null;
  editMode: boolean;
  editableContent: { [key: string]: string };
  button1Text: string;
  button2Text: string;
  button3Text: string;
  button4Text: string;
  button5Text: string;
  button6Text: string;
  handleSectionClick: (section: string) => void;
  handleEditChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
  setButton1Text: React.Dispatch<React.SetStateAction<string>>;
  setButton2Text: React.Dispatch<React.SetStateAction<string>>;
  setButton3Text: React.Dispatch<React.SetStateAction<string>>;
  setButton4Text: React.Dispatch<React.SetStateAction<string>>;
  setButton5Text: React.Dispatch<React.SetStateAction<string>>;
  setButton6Text: React.Dispatch<React.SetStateAction<string>>;
}

const ButtonsEditor: React.FC<ButtonsEditorProps> = ({
  selectedSection,
  editMode,
  editableContent,
  button1Text,
  button2Text,
  button3Text,
  button4Text,
  button5Text,
  button6Text,
  handleSectionClick,
  handleEditChange,
  handleSaveChanges,
  handleCancelEdit,
  setButton1Text,
  setButton2Text,
  setButton3Text,
  setButton4Text,
  setButton5Text,
  setButton6Text,
}) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section);
  };
  const handleSave = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevenir el comportamiento por defecto
    handleSaveChanges();
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevenir el comportamiento por defecto
    handleCancelEdit();
  };

  return (
    <div className="buttons-editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => toggleSection('buttons')}>Botones</h3>
        {activeSection === 'buttons' && (
          <div className="accordion-content">
            {/* Botón 1 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-1-link')}
                className={selectedSection === 'button-1-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 1
              </button>
              {editMode && selectedSection === 'button-1-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 1</h4>
                  <input
                    type="text"
                    name="button-1-text"
                    value={button1Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton1Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-1-link"
                    value={editableContent['button-1-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Botón 2 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-2-link')}
                className={selectedSection === 'button-2-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 2
              </button>
              {editMode && selectedSection === 'button-2-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 2</h4>
                  <input
                    type="text"
                    name="button-2-text"
                    value={button2Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton2Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-2-link"
                    value={editableContent['button-2-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Botón 3 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-3-link')}
                className={selectedSection === 'button-3-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 3
              </button>
              {editMode && selectedSection === 'button-3-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 3</h4>
                  <input
                    type="text"
                    name="button-3-text"
                    value={button3Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton3Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-3-link"
                    value={editableContent['button-3-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Botón 4 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-4-link')}
                className={selectedSection === 'button-4-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 4
              </button>
              {editMode && selectedSection === 'button-4-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 4</h4>
                  <input
                    type="text"
                    name="button-4-text"
                    value={button4Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton4Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-4-link"
                    value={editableContent['button-4-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Botón 5 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-5-link')}
                className={selectedSection === 'button-5-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 5
              </button>
              {editMode && selectedSection === 'button-5-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 5</h4>
                  <input
                    type="text"
                    name="button-5-text"
                    value={button5Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton5Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-5-link"
                    value={editableContent['button-5-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Botón 6 */}
            <div className="button-item">
              <button
                onClick={() => handleSectionClick('button-6-link')}
                className={selectedSection === 'button-6-link' ? 'selected-menu-item' : ''}
              >
                Editar Botón 6
              </button>
              {editMode && selectedSection === 'button-6-link' && (
                <div className="editor-panel">
                  <h4>Editar Botón 6</h4>
                  <input
                    type="text"
                    name="button-6-text"
                    value={button6Text}
                    onChange={(e) => {
                      handleEditChange(e);
                      setButton6Text(e.target.value);
                    }}
                    placeholder="Texto del botón"
                  />
                  <input
                    type="text"
                    name="button-6-link"
                    value={editableContent['button-6-link'] || ''}
                    onChange={handleEditChange}
                    placeholder="Enlace del botón"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ButtonsEditor;
